import { render, staticRenderFns } from "./AcopioArticleDeliveries.vue?vue&type=template&id=405e51de&"
import script from "./AcopioArticleDeliveries.vue?vue&type=script&lang=js&"
export * from "./AcopioArticleDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports